module.exports = __webpack_public_path__ + "static/img/case_tab_14.a431792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_14.png
// module id = cyRZ
// module chunks = 34